// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\DTO.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
/**
 * 平台数据类型 DTO类
 * 平台数据类型
 */
export class PlatDataType {
  /** 名称 : 名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 简称 : 简称，模型使用的名称，用于用户快捷定义 */
  private _alias: string;

  /** 设置：简称 */
  public get alias() {
    return this._alias;
  }

  /** 获取：简称 */
  public set alias(value: string) {
    this._alias = value;
  }

  /** 全名 : 类型全名，简单类型与名称一致 */
  private _fullname: string;

  /** 设置：全名 */
  public get fullname() {
    return this._fullname;
  }

  /** 获取：全名 */
  public set fullname(value: string) {
    this._fullname = value;
  }

  /** 是否可空 : 是否可空 */
  private _isNullable: boolean;

  /** 设置：是否可空 */
  public get isNullable() {
    return this._isNullable;
  }

  /** 获取：是否可空 */
  public set isNullable(value: boolean) {
    this._isNullable = value;
  }

  /** 缺省值 : 缺省值 */
  private _defaultValue: string;

  /** 设置：缺省值 */
  public get defaultValue() {
    return this._defaultValue;
  }

  /** 获取：缺省值 */
  public set defaultValue(value: string) {
    this._defaultValue = value;
  }

  /** 数据类型枚举 : 数据类型枚举 */
  private _dataTypeEnum: EnumDataType;

  /** 设置：数据类型枚举 */
  public get dataTypeEnum() {
    return this._dataTypeEnum;
  }

  /** 获取：数据类型枚举 */
  public set dataTypeEnum(value: EnumDataType) {
    this._dataTypeEnum = value;
  }

  /** 是否简单类型 : 是否简单类型 */
  private _isPrimitive: boolean;

  /** 设置：是否简单类型 */
  public get isPrimitive() {
    return this._isPrimitive;
  }

  /** 获取：是否简单类型 */
  public set isPrimitive(value: boolean) {
    this._isPrimitive = value;
  }

  constructor() {
    this._name = '';
    this._alias = '';
    this._fullname = '';
    this._isNullable = true;
    this._defaultValue = '';
    this._dataTypeEnum = EnumDataType.String;
    this._isPrimitive = true;
  }

  public toJson(): any {
    const json = {};
    this.Serialize(json);
    return json;
  }

  protected Deserialize(json: any): void {
    this.name = json.Name;
    this.alias = json.Alias;
    this.fullname = json.Fullname;
    this.isNullable = json.IsNullable;
    this.defaultValue = json.DefaultValue;
    this.dataTypeEnum = json.DataTypeEnum as EnumDataType;
    this.isPrimitive = json.IsPrimitive;
  }

  protected Serialize(json: any): void {
    json.Name = this.name;
    json.Alias = this.alias;
    json.Fullname = this.fullname;
    json.IsNullable = this.isNullable;
    json.DefaultValue = this.defaultValue;
    json.DataTypeEnum = this.dataTypeEnum;
    json.IsPrimitive = this.isPrimitive;
  }

  static Create(json: any): PlatDataType {
    const platDataType = new PlatDataType();
    platDataType.Deserialize(json);
    return platDataType;
  }
}
